import Link from "next/link";

import { withBasePath } from "@/lib/base-path";
import { domainConfig } from "@/lib/domain/active-config";

export function HomepageLogo() {
  return (
    <Link
      href="/"
      aria-label={domainConfig.brand.name}
      lang="en"
      className="shrink-0 flex items-center gap-1"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={withBasePath(domainConfig.brand.logoSrc)}
        className="size-5"
        role="presentation"
      />
      <span className="text-[#011E41] font-semibold leading-5">
        {domainConfig.brand.name}
      </span>
    </Link>
  );
}
